module.exports = __webpack_public_path__ + "static/media/hp-group-tablet.58d2dd66.svg";